import { sendCustomEvent } from '@ad/ad_utils/src';
import { get, post } from '@/utils/request/mAxios';
import { AdvAssetsAuthResult } from './../auth/type';

const urlPrefix = '/tcpp/api';

class Apis {
  getSharedAssetsList = async (req: {
    shareToken: string;
    page: number;
    limit: number;
    folderId?: string;
  }) => {
    const res = await get(`${urlPrefix}/assets/share/list`, req);
    return res;
  };

  getAssetSharingMetaData = async (req: { shareToken: string }) => {
    const res = await get(`${urlPrefix}/assets/share/metadata`, req);
    return res;
  };

  getAdvertiserList = async () => {
    const res = await get(
      '/tcpp/api/user/advids',
      {},
      {
        showApiHint: false,
        overrideGlobalShowApiHint: true
      }
    );
    return res;
  };

  getFolderTree = async (req: { shareToken: string }) => {
    const res = await get(`${urlPrefix}/assets/share/tree`, req);
    return res;
  };

  sendVideoToTtam = async (req: {
    fileIds: string[];
    advIds: string[];
    shareToken: string;
    permissionType?: AdvAssetsAuthResult;
  }) => {
    sendCustomEvent('asset_share_send2Manage_btn', {
      status: req.permissionType
    });
    const res = await post('/tcpp/api/assets/advertiser/sync_to_ttam', req);
    return res;
  };
}

export const apis = new Apis();
